import { useMemo } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/base/BackToTop";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/entries";
import { siteConfig } from "@/mocks/site";
import Hero from "./components/Hero";
import Features from "./components/Features";
import HotEntries from "./components/HotEntries";
import CategoryGrid from "./components/CategoryGrid";
import FaqSection from "./components/FaqSection";
import Testimonials from "./components/Testimonials";
import ContactCta from "./components/ContactCta";

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteConfig.name,
        description: siteConfig.description,
        inLanguage: "zh-CN",
        url: window.location.origin,
        potentialAction: {
          "@type": "SearchAction",
          target: `${window.location.origin}/entries?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteConfig.name,
        description: siteConfig.description,
        email: siteConfig.email,
        url: window.location.origin,
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
    []
  );

  useSeo({
    title: "黑料百科 - 黑料百科事件详解与完整记录，一网打尽每一个瓜条",
    description:
      "黑料百科以事件词条方式整理网络热点，提供事件详解、事件背景与完整记录。从起因到各方回应，你想知道的这里都有，倡导理性吃瓜、不信谣不传谣。",
    keywords: "黑料百科,事件详解,事件词条,瓜条,百科大全,事件背景,完整记录",
    path: "/",
    jsonLd,
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <Hero />
        <Features />
        <HotEntries />
        <CategoryGrid />
        <FaqSection />
        <Testimonials />
        <ContactCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}